var multimediamodal = {
    badge: "NUEVO",
    heading: "Galería multimedia",
    intro: "Hemos agregado una galería multimedia a tu panel de control con fotografías, videos y recursos oficiales de la marca Marival Resorts. Para comenzar a utilizarla, te invitamos a revisar y aceptar los términos y condiciones que se presentan a continuación.",
    termsButton: "Leer términos y condiciones",
    acceptTextBefore: "He leído y acepto los términos y condiciones para el uso del ",
    acceptLinkText: "material multimedia de Marival Resorts",
    acceptTextAfter: ".",
    continueButton: "Continuar"
}
module.exports = multimediamodal
